import { IconWithText } from 'common/icon/icon-with-text.js';
import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { IAccessState, getAccessStatus } from 'utilities/status/state-access.js';
import { MarkerComponentType } from './utils.js';

export type SkiStatusItem = {
  key: MarkerComponentType.SkiStatus;
  index: string;
  skiStatus: IAccessState;
};

export const hasSkiStatus = ({ value, label, type }: ILocationSummary): SkiStatusItem | undefined => {
  if (type === MarkerTypeGeneral.Ski || type === MarkerTypeGeneral.National) {
    if (value.status) {
      const skiStatus = getAccessStatus(value.status);
      return {
        key: MarkerComponentType.SkiStatus,
        index: `${type}-${label}`,
        skiStatus,
      };
    }
  }
  return undefined;
};

export const SkiStatus = ({ skiStatus }: Pick<SkiStatusItem, 'skiStatus'>) => (
  <IconWithText
    icon={skiStatus.icon}
    classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-mL-xs"
    contentClass="u-hidden"
    iconClass="svg-fill-textSlate"
  />
);
